$(document).ready(function() {

    var closables = document.querySelectorAll('.is-modal-close');

    for (var i = 0; i < closables.length; i++)
    {
        var modal = closables[i];
        modal.addEventListener( 'click', closeModal );
    }

    document.onkeydown = function(e) {
        e = e || window.event;
        if (e.keyCode === 27) {
            closeModal();
        }
    };

});

function closeModal() {
    document.getElementById('modal').classList.remove('is-active');
}